<template>
  <div 
    id="ContactForm"
    :style="outerWrapperStyles">
    <div 
      :style="innerWrapperStyles" 
      class="form-wrapper">

      <div class="ctn-exit-btn">
        <button class="exit-btn newfont" @click="Exit">
          <span class="material-icons">clear</span>
        </button>
      </div>
      <div class="errorBox">
        {{ error }}
      </div>
      <h2 class="newfont titlemargin">{{title}}</h2>
      <form id="contactForm">
        <div class="input-grp">
          <label class="block-label newfont" for="email">Name</label>
          <div class="flex"><input class="textInput" v-model="firstName" type="text" placeholder="firstName" /></div>
          <div class="flex mg-sm"><input class="textInput" v-model="lastName" type="text" placeholder="lastName" /></div>
        </div>
        <div class="input-grp">
          <label class="block-label newfont" for="email">Email</label>
          <div class="flex"><input class="textInput" v-model="email" type="text" placeholder="email@provider.com" /></div>
        </div>
        <div class="input-grp">
          <label class="block-label newfont" for="password">Phone</label>
          <div class="flex"><input class="textInput" v-model="phone" type="text" placeholder="999-888-7777" /></div>
        </div>
        <div class="input-grp">
          <label class="block-label newfont" for="password">Message</label>
          <div><textarea id="contactFormTextArea" class="textarea" v-model="message" /></div>
        </div>
        <div id="ContactFormCaptcha" class=""></div>

        <div class="flexcc mg-sm2">
          <button class="button-std" @click.prevent="verify" type="submit">Submit</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>

import { defaultConfig } from '../utilities/Requester.js'
import { verifier } from '../utilities/Verifier.js'
export default {
  name: 'Contact',
  props: {
    msg: String,
    destination:{
      type:String,
      default:"/message"
    },
    captcha:{
      type:Boolean,
      default:false
    },
    title:{
      type:String,
      default:"Contact Request"
    },
    outerWrapperStyles:{
      type:Object,
      default:function(){return {}}
    },
    innerWrapperStyles:{
      type:Object,
      default:function(){return {}}
    }
  },
  data:function(){
    return {
      firstName:"",
      lastName:"",
      email:"",
      phone:"",
      message:"",
      error:""
    }
  },
  computed:{
    form:function(){
      let form = {
        firstName:this.firstName,
        lastName:this.lastName,
        email:this.email,
        phone:this.phone,
        message:this.message
      }
      if(this.captcha === true){
        form['captcha'] = window.grecaptcha.getResponse(window.captcha1);
      }
      return form;
    }
  },
  created(){
  },
  mounted(){
  },
  methods:{
    Exit(){
      this.$emit('exit');
    },
    resetForm(){
      this.firstName=""
      this.lastName=""
      this.email=""
      this.phone=""
      this.message=""
    },
    handleError(e){
      let err = e;
      if(e.response.data.message){
        err = `${e.response.data.message}`;
      }
      this.$emit('error', String(err));
    },
    verify(){

      let firstNameVerify = [{"minLength":2}];
      firstNameVerify.inputName = "First Name"
      let lastNameVerify = [{"minLength":2}];
      lastNameVerify.inputName = "Last Name"
      let emailVerify = [
        {"minLength":3},
        {"pattern":"email"},
        {"whitespace":""}]
      emailVerify.inputName = "Email "
      let phoneVerify = [
        {"minLength":9},
        {"whitespace":""},
        {"chars":[" ","1","2","3","4","5","6","7","8","9","0","-","(",")"]},
        {"limitchars":["(",")"],limit:1},
        {"limitchars":["-"],limit:3},
        {"maxLength":20}
      ];
      phoneVerify.inputName = "Phone"
      let messageVerify = [];
      messageVerify.inputName = "Message"

      let vList = [
        firstNameVerify,
        lastNameVerify,
        emailVerify,
        phoneVerify,
        messageVerify
      ]
      let iList = [
        this.firstName,
        this.lastName,
        this.email,
        this.phone,
        this.message
      ]
      let checks = []
      for(let i =0;i<vList.length;i++){
        let out = verifier(vList[i])(iList[i])
        if(out !== true){
          this.valueError = true;
          this.error = `${vList[i].inputName} ${out}`;
          setTimeout(() => {
            this.valueError = false;
            this.error = ""
          },9000)
          checks.length = 0
          break;
        }
        checks.push(true)
      }
      if(checks.every(x => x === true) && checks.length === 5){
        this.sendMessage()
      }

    },
    sendMessage(){
      let message = document.messageRequest(this.destination)
      let options = defaultConfig()
      options.method = "POST";
      options.headers['Content-Type'] = "application/json";
      options.data = JSON.stringify(this.form);
      let handleResponse = e => {
        this.$emit('success', e.data)
        this.resetForm()
      }
      message(options)
        .then(handleResponse)
        .catch(this.handleError)
    } 
  }
}
</script>

<style scoped>
#ContactForm {
  transition: all 0.5s ease;
}
.form-wrapper {
  box-sizing:border-box;
  position:relative;
  background:#ffffff;
  display: grid;
  min-height:100px;
  max-width:700px;
  grid-template-columns: 1fr;
  text-align:center;
  padding:0 2em;
  padding-bottom:1em;
  font-size:2em;
  border: 8px solid #d9d9d9;
  border-radius: 15px;
}
.input-grp {
  text-align:left;
  margin-bottom:15px;
}
.neg-marg {
  margin-top:-10px;
}
.textInput {
  font-size:.6em;
  width:100%;
}
.textarea {
  min-width:400px;
  min-height:200px;
}
.mg-sm {
  margin-top:5px;
}
.mg-sm2 {
  margin-top:10px;
}
.border {
  border: 1px dashed navy;
}
.flex {
  display:flex;
}
.newfont {
  font-family:'Bodoni Elegant Regular';
  font-weight:100;
}
.errorBox {
  position:absolute;
  top: 10px;
  left: 10px;
  background:white;
  color:red;
  z-index:22;
}
.button-std {
  background-color:#325DFF;
  color:#fff;
  font-weight:600;
  padding: 10px 20px;
  border-radius:9px;
  cursor:pointer;
  display:flex;
  align-items:center;
  cursor:pointer;
  transition: all 0.4s ease-in-out;
}
.button-std:hover {
  background-color:#32d8ff;
  transition: all 0.4s ease-in-out;
}
.flexcc {
  display:flex;
  justify-content:center;
  align-items:center;
}
.exit-btn {
  background-color:#7b7b7b;
  color:#fff;
  font-weight:600;
  font-size:1.2em;
  padding: 8px 8px;
  border:none;
  border-radius:9px;
  display:flex;
  align-items:center;
  cursor:pointer;
  transition: all 0.4s ease-in-out;
}
.exit-btn:hover {
  background-color:black;
  transition: all 0.4s ease-in-out;
}
.ctn-exit-btn {
  position: absolute;
  top: 2%;
  left: 2%;
}
@media only screen and (max-width: 600px) {
  .form-wrapper {
    max-width:350px;
    padding:10px;
  }
  .textInput {
    width:80%;
  }
  .textarea {
    min-width:0;
    width:90%;
    max-height:100px;
  }
  .titlemargin {
    margin:15px 0px;  
  }
}
</style>
